<template>
  <ul :class="$style.legend">
    <li v-for="l in legendArr" :key="l.title" :class="$style.legend__item">
      <img :src="icons[l.value]" :class="$style.legend__item_img" />
      <span>{{l.title}}</span>
      <span :class="[$style.info, $style[l.class]]">{{l.value}}</span>
    </li>
  </ul>
</template>

<script>
import { ICON } from '@/components/@ui/wrapper-matrix/users'

export const legend = [
  { title: 'Лайк', value: 10, class: 'red' },
  { title: 'Прослушал', value: 1, class: 'cercle' },
  { title: 'Не известно', value: 0, class: 'gray' },
  { title: 'Скип', value: -1, class: 'gray' },
  { title: 'Дизлайк', value: -10, class: 'gray' },
]

export default {
  name: 'legend-matrix',
  setup() {
    return {
      legendArr: legend,
      icons: ICON,
    }
  },
}
</script>

<style scoped lang="scss" module>
$red: #FF2323;
.legend {
  padding: 0;
  position: absolute;
  left: 5rem;
  top: 50%;
  transform: translateY(-50%);
  margin: 0;

  @media (max-width: $tabletWidth) {
    left: auto;
    right: 25rem;
  }
  @media (max-width: $mobileWidth) {
    right: auto;
    top:  5rem;
    transform: none;
  }

  &__item{
    display: flex;
    align-items: center;
    color: $white;
    font-size: 1.6rem;
    line-height: 2.1rem;
    margin-bottom: 1.9rem;
    &_img {
      max-width: 100%;
      width: 3.2rem;
      margin-right: 1.9rem;
    }
  }
  .info {
    width: 2.6rem;
    height: 2.6rem;
    border-radius: 50%;
    text-align: center;
    font-size: 1.4rem;
    line-height: 1.8rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 0.5rem;
  }
  .red {
    background-color: $red;
  }
  .cercle {
    background: transparent;
    border: 1px solid $red;
  }
  .gray {
    background: rgba(255, 255, 255, 0.2);
  }
}

</style>
